import React, { useState, useEffect, useRef } from "react";
import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import { FaHandHoldingWater, FaSchool, FaDownload, FaPeopleCarry, FaFilter } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood, IoMan } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { GiTeacher } from "react-icons/gi";
import { IoMdArrowRoundBack, IoMdNotificationsOutline } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper"
import ApexChartMonthWise from "./ApexChartMonthWise";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
// import healthy from "../../../assets/images/ekped.png";
import HeaderAdmin from "../../HeaderAdmin";
import { toast } from "react-toastify";
import CircleChartTrees from "./piechartTrees.jsx";
import { FaAngleDown } from "react-icons/fa6";
import { FcCollaboration } from "react-icons/fc";
import DynamicCount from "../../../helper/AutoMation";
import LineChartTrees from "./LineChart3.jsx";
import ApexChartHeatmap from './ApexHeatChart3';
import ApexChartHeatmap2 from './ApexHeatChart4';
import BarChartsTrees from "./BarChartTrees";
import TreeIcon from "../../../assets/images/tree-icon.png";
import WardIcon from "../../../assets/images/total-ward.png";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { IoMdRefreshCircle } from "react-icons/io";
import * as XLSX from 'xlsx';

function Ekpedmaakenaam() {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const [apiData, setApiData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFilterShow, setIsFilterShow] = useState(false);
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [filteredSchool, setFilteredSchool] = useState([]);
    const [stateID, setStateID] = useState('');
    const [selectYear, setYear] = useState('');
    const [chartStatus, setChartStatus] = useState(1);
    const [timeFilter, setTimeFilter] = useState(false);
    const [quickNum, setQuickNum] = useState("");
    const [selectedDuration, setSelectedDuration] = useState("");
    const [notificationData, setNotificationData] = useState(null);
    const [notificationCount, setNotificationCount] = useState(0);
    const [downloadingReport, setDownloadingReport] = useState(false);
    
    const stateNames = location.state?.stateValue;

  if (stateNames) {
    localStorage.setItem("filterDataState", stateNames);
  }
    const [filterData, setFilterData] = useState({
        state: stateNames,
        district: "",
        school_name: "",
        theme_name: "",
        sub_themes: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    });
    let totaltrees=0;
    let totalstudents=0;
    
    // Fetch API data on mount or when filterData.state changes
    useEffect(() => {
        setLoading(true);
        setError(null);
        fetch('https://ecoclubs.education.gov.in/api/ekped-allrecords-admin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ state: "CENTRAL" }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    setApiData(data); // store the whole response
                } else {
                    setError('Failed to fetch data');
                }
                setLoading(false);
            })
            .catch(err => {
                setError('Failed to fetch data');
                setLoading(false);
            });
    }, [filterData.state]);

    // Fetch notification data
    useEffect(() => {
        fetchNotificationData();
    }, []);

    const fetchNotificationData = async () => {
        try {
            const response = await fetch('https://ecoclubs.education.gov.in/api/school-notifications/all-states', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.status === "success") {
                setNotificationData(data);

            }
        } catch (error) {
            console.error("Error fetching notification data:", error);
        }
    };

    // Other useEffect hooks (move here, before any return)
    useEffect(() => {
  if (notificationData) {
    // For central admin, use totalCount directly from API response
    const totalNotifications = notificationData.totalCount || 0;
    setNotificationCount(totalNotifications);
    console.log('Total notifications for central admin:', totalNotifications);
    console.log('State-wise notification counts:', notificationData.stateCounts);
  }
}, [notificationData]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeFilter(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Derived values from API data
    const treesCount = apiData?.totalTrees || 0;
    const schoolsCount = apiData?.totalSchools || 0;
    const stateWiseData = apiData?.states || [];
    // let notificationCount =  0;
    const stateWiseNotifications = notificationData?.stateCounts || [];
    

        // Accordion state for school type categories
        const [isSchoolTypeOpen, setIsSchoolTypeOpen] = useState(false);

        // Mapping for numeric school type IDs to names
        const schoolTypeIdMapping = {
            6: 'Other State Govt. Managed',
            98: 'Other'
        };

        // Helper to get national school_type summary counts (from NotificationReport.jsx)
        function getNationalSchoolTypeSummary(stateData) {
            const summary = {};
            let totalProcessed = 0;
            let totalNotifications = 0;
            
            stateData.forEach(state => {
                // Track total notifications from state count
                totalNotifications += state.count || 0;
                
                if (Array.isArray(state.schoolTypes)) {
                    state.schoolTypes.forEach(st => {
                        // Include both string and numeric school types
                        const schoolType = st.school_type;
                        
                        // Filter out only null, undefined, or empty strings
                        if (schoolType !== null && 
                            schoolType !== undefined && 
                            schoolType !== '' && 
                            String(schoolType).toLowerCase() !== 'undefined') {
                            
                            // Convert to string for consistent key handling
                            const key = String(schoolType);
                            if (!summary[key]) summary[key] = 0;
                            summary[key] += st.count;
                            totalProcessed += st.count;
                            
                            console.log(`✅ Added ${st.count} notifications from school_type: ${schoolType} (${typeof schoolType})`);
                        }
                    });
                }
            });
            
            // Calculate missing notifications (where school_type is null/empty/missing)
            const missingCount = totalNotifications - totalProcessed;

            if (missingCount > 0) {
                // Merge into existing 'Other' if present, otherwise create
                summary['Other'] = (summary['Other'] || 0) + missingCount;
                console.log(`⚠️ Added ${missingCount} notifications with missing/empty school_type to 'Other' category`);
            }

            // Some data sources send numeric codes (e.g. "8") that should be grouped under 'Other'.
            // If such keys exist, merge them into the 'Other' bucket to avoid duplicate categories.
            if (summary['8']) {
                summary['Other'] = (summary['Other'] || 0) + summary['8'];
                console.log(`🔀 Merged ${summary['8']} items from key '8' into 'Other'`);
                delete summary['8'];
            }

            console.log('📊 Final Summary:', summary);
            console.log('📊 Total in Summary:', Object.values(summary).reduce((sum, val) => sum + val, 0));
            console.log('📊 Expected Total:', totalNotifications);
            console.log(`✅ Count Match: ${Object.values(summary).reduce((sum, val) => sum + val, 0) === totalNotifications ? 'YES' : 'NO'}`);
            
            return summary;
        }

        // Compute school type summary from notificationData
        const schoolTypeSummary = notificationData && notificationData.stateCounts
            ? getNationalSchoolTypeSummary(notificationData.stateCounts)
            : {};
    // Place loading/error checks after all hooks
    if (loading) {
        return <div style={{textAlign: 'center', marginTop: 40}}><h3>Loading...</h3></div>;
    }
    // if (error) {
    //     return <div style={{textAlign: 'center', marginTop: 40, color: 'red'}}><h3>{error}</h3></div>;
    // }

    // Placeholder for map view
    const MapView = () => (
      <div style={{ width: '100%', height: 300, background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
        <span style={{ color: '#888', fontWeight: 'bold' }}>[Map View Placeholder]</span>
      </div>
    );

    const handleSelectState = (data) => {
        setStateID(data);
        setFilteredSchool([])
        let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
        console.log('filterdistrictList', filterdistrictList)
        setFilterDistrict(filterdistrictList);
        setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
        getSchoolList({ state_id: data })
    }

    const handleSelectDistrict = async (value) => {
        setFilteredSchool([])
        setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
        let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
        getSchoolList({ state_id: stateID, district_id: districtid })
    }

    const handleSelectTheme = async (value) => {
        setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
    }

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      setSelectedDuration(`${filterData.fromDate} to ${value}`);
      if (
        filterData?.fromDate &&
        new Date(filterData?.fromDate) > new Date(value)
      ) {
        toast.error("Start date cannot be greater than end date");
        return;
      }
    }
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
    if (field === "fromDate" || field === "toDate") {
      setQuickNum("");
    }
  };

    const getSchoolList = async (data) => {
        try {
            let response = await axiosConn('post', 'get-school-filter', data)
            if (response.data.status === 'success') {
                setFilteredSchool(response.data.result)
            }
        } catch (error) {
            console.log(error);
        }
    }

    

    const handleClickFilter = (district, filter) => {
        let data = { ...filterData, district };
        data['district'] = district;

        if (filter) {
            if (filter.implemnt_mode) {
                data['implemnt_mode'] = filter.implemnt_mode;
            }
            if (filter.event_type) {
                data['event_type'] = filter.event_type;
            }
        }
        navigate("/admin/state-level/view-district-trees", { state: { state:apiData?.state , data: data } })
    }
    
    

    const applyQuickSelect = (quickSelect) => {
        const today = new Date();
        let startDate = null;
        let endDate = new Date();
    
        const quickSelectRanges = {
            last3Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 3);
            },
            last7Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 7);
            },
            last15Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 15);
            },
            lastMonth: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
            },
            last3Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 3);
            },
            last6Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 6);
            },
            currentYear: () => {
                startDate = new Date(today.getFullYear(), 0, 1);
            },
            previousYear: () => {
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
            },
        };
    
        if (quickSelectRanges[quickSelect]) {
            quickSelectRanges[quickSelect]();
        } else {
            return;
        }

        setSelectedDuration(
            `${startDate.toISOString().split("T")[0]} to ${
              endDate.toISOString().split("T")[0]
            }`
          );
    
        setFilterData(prevData => ({
            ...prevData,
            fromDate: startDate.toISOString().split('T')[0],
            toDate: endDate.toISOString().split('T')[0]
        }));
        setTimeFilter(false);
    };

const handleQuickSelect = (period) => {
    applyQuickSelect(period);
};
    // Function to calculate start and end dates of the selected year
    const calculateYearRange = (year) => {
        if (!year) return { start: '', end: Helper.currentOrPastDate() };

        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;

        return { start: startDate, end: endDate };
    };
    // Calculate the date range for the selected year
    const { start, end } = calculateYearRange(selectYear);

const exportDashboardToPDF = async () => {
  const pdf = new jsPDF("p", "pt", "a4");
  let yPos = 20;

  // Title
  pdf.setFontSize(20);
  pdf.setTextColor("#4A4A4A");
  pdf.text("Superadmin Dashboard", 20, yPos);
  yPos += 40;

  // Total Stats Section
  pdf.setFontSize(14);
  pdf.setTextColor("#0080FF");
  pdf.text("Total Stats", 20, yPos);
  yPos += 25;
  pdf.setFontSize(12);
  pdf.setTextColor("#000000");
  pdf.text(`Total Trees Planted: ${treesCount}`, 20, yPos);
  yPos += 18;
  pdf.text(`Total Schools Participated: ${schoolsCount}`, 20, yPos);
  yPos += 30;

  // District/State-wise Table
  pdf.setFontSize(14);
  pdf.setTextColor("#0080FF");
  pdf.text("States/UTs/ABs-wise Stats", 20, yPos);
  yPos += 25;

  const tableHeader = ["#", "States/UTs/ABs", "Trees Planted", "Schools Participated"];
  const tableBody = stateWiseData.map((item, idx) => [
    idx + 1,
    item.name || '-',
    item.totalTrees || 0,
    item.totalSchools || 0
  ]);

  pdf.autoTable({
    startY: yPos,
    head: [tableHeader],
    body: tableBody,
    theme: "grid",
    styles: { halign: "center" },
  });

  pdf.save("State_admin_Dashboard_Summary.pdf");
};


const currentPath = window.location.pathname;

const transformObjectToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => ({
    name: key,
    value,
  }));
};

const exportAllDataToExcel = async () => {
  const workbook = XLSX.utils.book_new();

  // Total Stats Sheet
  const totalStatsSheetData = [
    ["Total Trees Planted", treesCount],
    ["Total Schools Participated", schoolsCount],
  ];
  const totalStatsSheet = XLSX.utils.aoa_to_sheet(totalStatsSheetData);
  XLSX.utils.book_append_sheet(workbook, totalStatsSheet, "Total Stats");

  // State-wise Sheet
  const stateWiseSheetData = [
    ["#", "States/UTs/ABs", "Trees Planted", "Schools Participated"],
    ...stateWiseData.map((item, idx) => [
      idx + 1,
      item.name || '-',
      item.totalTrees || 0,
      item.totalSchools || 0
    ])
  ];
  const stateWiseSheet = XLSX.utils.aoa_to_sheet(stateWiseSheetData);
  XLSX.utils.book_append_sheet(workbook, stateWiseSheet, "States-UTs-ABs-wise Stats");

  // Save the Excel file
  XLSX.writeFile(workbook, 'State_admin_Dashboard_Summary.xlsx');
};






const resetFilterData = () => {
    setStateID('');
    setFilterDistrict([]);
    setFilteredSchool([]);
    setFilterData({
        state: "",
        district: "",
        school_name: "",
        theme_name: "",
        sub_themes: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    });
    window.location.reload();
};

    // Helper to format date as '5th June 2025'
    

    // Generate the refresh message
    

    const handleDownloadThemesReport = async () => {
        if (downloadingReport) return;
        setDownloadingReport(true);
        const toastId = toast.info("Generating Report...", { autoClose: false });

        try {
            toast.update(toastId, {
                render: "Downloading Report...",
                type: "info",
                autoClose: false
            });

            const queryParams = new URLSearchParams();
            if (filterData.fromDate) queryParams.append("fromDate", filterData.fromDate);
            if (filterData.toDate) queryParams.append("toDate", filterData.toDate);
            const response = await fetch(`https://ecoclubs.education.gov.in/api/reports/themes?${queryParams.toString()}`, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error("Failed to generate report");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "EcoClubs_Themes_Report.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            toast.update(toastId, {
                render: "Success Message: Themes Analytics Report downloaded successfully!",
                type: "success",
                autoClose: 3000
            });
        } catch (err) {
            console.error(err);
            toast.update(toastId, {
                render: "Failed to download Themes report.",
                type: "error",
                autoClose: 3000
            });
        } finally {
            setDownloadingReport(false);
        }
    };

    return (
        <>
        <HeaderAdmin />
            <section className="scholdashbrdSec superAdminDashboardSec">
                <Container fluid>
                    <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
                        <h1 style={{ color: 'orange' }}>EK PED MAA KE NAAM 2.0</h1>
                        <h2>NATIONAL<span className="hdngBrkr"></span> SNAPSHOT</h2>
                        <h3 style={{letterSpacing: "0.1em"}}>Welcome Central Admin</h3>
                        {/* <h6 style={{letterSpacing: "0.1em",color:'#be3441'}}>{getRefreshMessage()}</h6> */}
                        <div className="text-end">
                            <Button onClick={handleDownloadThemesReport} disabled={downloadingReport} className="me-2 mt-2 mt-md-0" style={{ background: 'linear-gradient(45deg, #17a2b8, #117a8b)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s', color: 'white', fontWeight: 'bold' }}>
                                📊 Download Themes Report
                            </Button>
                            <Button onClick={exportDashboardToPDF} className="me-2"><FaDownload size={20} color="#dddddd" /> Download PDF</Button>
                            <Button onClick={exportAllDataToExcel} variant="success" className="me-2"><FaDownload size={20} color="#dddddd" /> Download Excel</Button>
                             <Link to="/admin"><Button className="me-2">MAIN ECO CLUBS DASHBOARD</Button></Link> 
                              <Link to="/admin/environment-day-dashboard">
                                <Button className="btn-success mt-2 mt-md-0 me-2" style={{background: 'linear-gradient(45deg, #28a745, #218838)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s'}}>
                                    <MdOutlineEnergySavingsLeaf size={20} style={{marginRight: '8px'}}/> View Environment Day Dashboard
                                </Button>
                            </Link>
                            <Link to="/admin/themes-analytics">
                                <Button className="btn-info mt-2 mt-md-0" style={{background: 'linear-gradient(45deg, #17a2b8, #117a8b)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s', color: 'white', fontWeight: 'bold'}}>
                                    📊 View Themes Analytics Dashboard
                                </Button>
                            </Link>
                        </div>
                    </div>

                    <div className="dashbrdTopSrchDivlavel mt-2 mb-0" style={{position:"relative", zIndex:0}}>
                        <div className="d-flex justify-content-center">
                            <div className="boxdiv boxdivOne">
                                <div className="d-flex justify-content-between p-3">
                                    <div>
                                        <p> TREES <span className="text-success w100">PLANTED</span></p>
                                    </div>
                                    <img src={TreeIcon} alt="School Icon" style={{width:82, height:82}} />
                                </div>
                                <div className="d-flex justify-content-center bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{treesCount}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivTwo">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>NUMBER OF <span className="text-success w100">SCHOOLS PARTICIPATED</span></p>
                                    </div>
                                    <FaSchool size={82} color="#9c6829" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{schoolsCount}</h2>
                                    </div>
                                </div>
                            </div>
                            
                            <div 
                                className="boxdiv boxdivThree" 
                                
                            >
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Total <span className="text-success w100">Notifications Uploaded</span></p>
                                    </div>
                                    <IoMdNotificationsOutline color="#9f4d9b " size={82}/>
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{notificationCount}</h2>
                                    </div>
                                </div>
                            </div>
                            
                            {/* <div className="boxdiv boxdivFour">
                                <div className="d-flex justify-content-between p-3">
                                    <div>
                                        <p>TOTAL UNIQUE <span className="text-success w100">BLOCKS/DISTRICTS</span></p>
                                    </div>
                                    <img src={WardIcon} alt="School Icon" style={{width:82, height:82}} />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{blockNames.length}</h2>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                                </Container>

                                {/* National School Type Categories Accordion */}
                                <Container fluid>
                                    <div className="school-type-section" style={{ margin: '30px 0' }}>
                                        <button
                                            className="accordion-toggle"
                                            style={{
                                                width: '100%',
                                                background: '#43b649',
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: 18,
                                                border: 'none',
                                                borderRadius: 16,
                                                padding: '8px 0',
                                                marginBottom: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'background 0.2s',
                                                minHeight: 40,
                                                height: 48
                                            }}
                                            onClick={() => setIsSchoolTypeOpen(!isSchoolTypeOpen)}
                                            aria-expanded={isSchoolTypeOpen}
                                        >
                                            <span style={{ flex: 1, textAlign: 'center', fontSize: 18 }}>
                                                NATIONAL SCHOOL TYPE CATEGORIES ({Object.keys(schoolTypeSummary).length})
                                            </span>
                                            <span style={{ fontSize: 22, marginLeft: 12, transition: 'transform 0.2s', transform: isSchoolTypeOpen ? 'rotate(180deg)' : 'none' }}>
                                                ▼
                                            </span>
                                        </button>
                                        <div style={{ transition: 'max-height 0.3s', overflow: 'hidden' }}>
                                            {isSchoolTypeOpen && (
                                                <div className="district-cards-grid" style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                                    gap: 18,
                                                    marginTop: 18,
                                                    justifyItems: 'center',
                                                    alignItems: 'center',
                                                }}>
                                                    {Object.entries(schoolTypeSummary).map(([type, count]) => (
                                                        <div key={type} className="district-card" style={{
                                                            width: '100%',
                                                            maxWidth: 160,
                                                            background: 'white',
                                                            border: '2px solid #43b649',
                                                            borderRadius: 12,
                                                            padding: '10px 6px',
                                                            textAlign: 'center',
                                                            boxShadow: '0 2px 8px #0001',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            height: 70,
                                                            margin: '0 auto',
                                                        }}>
                                                            <div className="district-card-name" style={{ fontWeight: 700, fontSize: 11, color: '#2d3a22', marginBottom: 2, lineHeight: 1.1 }}>{type}</div>
                                                            <div className="district-card-count" style={{ fontWeight: 800, fontSize: 18, color: '#2d3a22', marginTop: 1 }}>{count.toLocaleString("en-IN")}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Container>

                {/* State Table and Impact Section, always visible */}
                <Container fluid>
                  <div className="container-wrapper mt-4">
                    <h4>Trees Planted (States/UTs/ABs Wise)</h4>
                    <Table hover striped className="w-100">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>States/UTs/ABs</th>
                          <th>Trees Planted</th>
                          <th>Schools</th>
                          <th>Notifications</th>
                          <th>Action</th>
                          <th>Download</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {stateWiseData.map((item, index) => {
                            // Make case-insensitive comparison for state names
                            const notificationCount = stateWiseNotifications.find(n => 
                                n.state?.toUpperCase() === item.name?.toUpperCase()
                            )?.count || 0;
                            
                            console.log(`State: ${item.name}, Notification Count: ${notificationCount}`);
                            
                            return (
                                totaltrees += item.totalTrees,
                                totalstudents += item.totalSchools,
                              <tr key={item.name + index}>
                                <td>{index + 1}</td>
                                <td>{item.name || '-'}</td>
                                <td><b>{item.totalTrees}</b></td>
                                <td><b>{item.totalSchools}</b></td>
                                <td>
                                  <span 
                                    style={{ 
                                      cursor: 'pointer', 
                                      color: '#007bff', 
                                      textDecoration: 'underline',
                                      fontWeight: 'bold'
                                    }}
                                    onClick={() => navigate('/view-schools-notifications', { 
                                        state: { 
                                            state: item.name 
                                        } 
                                    })}
                                    onMouseEnter={(e) => {
                                        e.target.style.color = '#0056b3';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.color = '#007bff';
                                    }}
                                  >
                                    <b>{notificationCount}</b>
                                  </span>
                                </td>
                                <td>
                                <Button
  className="btn btn-primary btn-sm"
  onClick={() => navigate('/Ekpedmaakenaamadmin/district-wise', { state: { state: item.name } })}
>
  View Districts
</Button>
                             

                                </td>
                                
                                <td>
                                {/* <Button
  className="btn btn-primary btn-sm"
  onClick={() =>
    (window.location.href = `https://ecoclubs.education.gov.in/viewUpload/uploads/stats/${item.name}.pdf`)
  }
>
  School Wise Data
</Button> */}
 <Button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    (window.location.href = `https://ecoclubsmissionlife.blob.core.windows.net/ecoclubs-missionlife-container/${item.name?.toUpperCase()}.xlsx?sp=r&st=2025-08-19T15:14:18Z&se=2026-12-30T23:29:18Z&spr=https&sv=2024-11-04&sr=c&sig=nZE%2BPBAMO2sKIFrNP80OjvYYY7bojSBMTvspPIPLVsg%3D`)
                                  }
                                >
                                  School Wise Data
                                </Button>

                             

                                </td>
                              </tr>
                            );
                        })}
                        {/* <tr>
                          <td colSpan="2" style={{ textAlign: 'right' }}><b>Total</b></td>
                          <td><b>{totaltrees}</b></td>
                          <td><b>{totalstudents}</b></td>
                          <td colSpan="2"></td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                </Container>

            </section >
        </>
    );
}

export default Ekpedmaakenaam;
